/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import gql from 'graphql-tag';

/**
 * @param {string} brand - baskets or berries
 * @param {string} productType - gpt or fpt
 * @param {string} userType - passport or non passport
 */
const findCalendar = () => (
    // very important for serializing. add space between bracket and query name + add typenames to query
    gql`
        query PDPCalendarQuery($productType: String!, $userType: String!, $brand: String!, $environment: String!) {
            findCalendar(brand: $brand, environment: $environment, productType: $productType, userType: $userType)
            {
                content
            }
        }`
);

export default findCalendar;
